import { useQuery } from '@apollo/client';
import { ISelectOption, ISelectProps, Select } from '@busybusy/webapp-react-ui';
import { COST_CODE_GROUPS_QUERY } from 'apollo/queries/cost-code-group-queries';
import classNames from 'classnames';
import { useEffect, useState } from 'react';
import ICostCodeGroup from 'types/CostCodeGroup';
import { ALL_GROUPS, NO_GROUP } from 'utils/constants/stringConstants';
import { t } from 'utils/localize';

export interface ICostCodeGroupSelectProps extends Omit<ISelectProps, 'options'> {
  includeAllCostCodes: boolean;
  includeNoCostCodes: boolean;
  className?: string | object;
}

const CostCodeGroupSelect = (props: ICostCodeGroupSelectProps) => {
  const { includeAllCostCodes, includeNoCostCodes, className, ...selectProps } = props;

  const [options, setOptions] = useState<ISelectOption[]>([{ label: t('All Cost Codes'), value: ALL_GROUPS }]);
  const { data } = useQuery<{ costCodeGroups: ICostCodeGroup[] }>(COST_CODE_GROUPS_QUERY, {
    variables: { filter: { deletedOn: { isNull: true } } },
  });

  useEffect(() => {
    if (data) {
      const opts = [];

      if (includeAllCostCodes) {
        opts.push({ label: t('All Cost Codes'), value: ALL_GROUPS });
      }

      opts.push(...data.costCodeGroups.map((group) => ({ value: group.id, label: group.groupName })));

      if (includeNoCostCodes) {
        opts.push({ label: t('No Group'), value: NO_GROUP });
      }

      setOptions(opts);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data]);

  const classes = classNames(
    {
      'group-picker': true,
    },
    className
  );

  return <Select {...selectProps} options={options} className={classes} />;
};

CostCodeGroupSelect.defaultProps = {
  ...Select.defaultProps,
  includeAllCostCodes: true,
  includeNoCostCodes: true,
};

export default CostCodeGroupSelect;
